<template>
  <div :class="{ centered: true, 'align-start': top }">
    <v-container>
      <router-link to="/" v-if="!top">
        <img
          alt="logo"
          :src="require('@/assets/img/logo.png')"
          width="185"
          class="mb-5"
        />
      </router-link>
      <slot />
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    top: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.centered {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: calc(100vh - 5rem);
}
</style>
